import { render, staticRenderFns } from "./Dialog_WorkloadDetail.vue?vue&type=template&id=a3c64860&scoped=true&"
import script from "./Dialog_WorkloadDetail.vue?vue&type=script&lang=js&"
export * from "./Dialog_WorkloadDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c64860",
  null
  
)

export default component.exports